
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare-supplement",
      function () {
        return require("private-next-pages/medicare-supplement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare-supplement"])
      });
    }
  